<script>
    import {createEventDispatcher} from 'svelte';
    //import Input from './Input.svelte';
    //import { onMount } from 'svelte';

    const dispatch = createEventDispatcher();

    let container;

    export function adjustPosition ({top, left}) {
        container.style.top = `${top}px`;
        container.style.left = `${left}px`;
    }
    export function hiddenshow() {
      //console.log("sipcontainer", container.style);
      container.style.display = container.style.display === 'none' ? 'block' : 'none';
    }

    export let format_opts = {pixel: '1', filter: '1', channel: '1', pixelsize: '512', proj: 'WGS-84' };

    //$: document.format_opts = format_opts;


</script>

<div class="scene-info sip" style="width:250px; text-align: left; margin-left:10px; margin-right:10px; padding:10px" bind:this="{container}">
    <span>
        <i style="display: block; margin-left: auto; left: 50%;" class="icon close"></i>
    </span>
    <br/>
    <div on:change="{() => dispatch('change', format_opts)}">
      <label for="pixel">Изменение динамического диапазона (Формат пикселя)</label>
      <br/>
      <select label="Pixel" bind:value={format_opts.pixel} id="pixel" name="pixel" style="width:100%" >
        <option value="1">byte</option>
        <option value="2">int16</option>
        <option value="3">uint16</option>
        <option value="4">float32</option>
      </select>
      <br/>
      <span>Фильтр передискретизации</span>
      <br/>
      <select bind:value={format_opts.filter} id="filter" name="filter" style="width:100%">
        <option value="1">Эрмитовые сплайны</option>
        <option value="2">Линейный</option>
        <option value="3">Ближайший сосед</option>
        <option value="4">Фильтр Ланцоша</option>
        <option value="5">Бикубические сплайны</option>
      </select>
      <br/>
      <span>Размер пикселя</span>
      <br/>
      <input bind:value={format_opts.pixelsize} type="text" style="width:80%" name="pixelsize"/>
      <br/>
      <span>Проекция</span>
      <br/>
      <input bind:value={format_opts.proj} type="text" style="width:80%" name="proj"/>
      <br/>
      <span>Канал</span>
      <br/>
      <select bind:value={format_opts.channel} id="channel" name="channel" style="width:100%" >
        <option value="1">RGB(Red-Green-Blue)</option>
        <option value="2">NRG(Nir-Red-Green)</option>
        <option value="3">RGBN(Red-Green-Blue-Nir)</option>
        <option value="4">All channels</option>
      </select>
    </div>
</div>

<style>

div{
  background: #FFFFFF;
  border: 1px solid #D8E1E8;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.11);
  border-radius: 4px;
}

</style>
